import React, { Component } from 'react';

import { formatCurrency, debounce, sorts } from '../utils';
import productUtils from '../utils/productUtils';
import classnames from 'classnames';

import FormattedPlural from '../components/FormattedPlural.jsx';
import FormattedNumber from '../components/FormattedNumber.jsx';
import { Link } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import AuthorList from './product/AuthorList.jsx';
import ProductImage from '../components/product/ProductImage.jsx';
import AddButton from '../components/product/AddButton.jsx';
import PackageSelect from '../components/product/PackageSelect.jsx';
import Input from '../components/form/Input.jsx';

const reasons = {
    order: [
        // 'Product arrived broken',
        ['Wrong Product', 'Prod Err'],
        ['Ordering Error', 'ND:1'],
        ['Duplicate Order', 'ND:2'],
        ['Returning Sample Unit', 'ND:3'] // | always Warranty
    ],
    playaway: [
        ['Player or Audio Failure During Playback', 'FADE-6.0'],
        ['Unit Will Not Power On', 'PWR-6.0'],
        ['Screen Is Dim, Distored, Broken', 'LCD-6.0'],
        ['Keypad/Buttons Not Responding', 'KP-6.0'],
        ['No Sound / Aux Port is Defective', 'PJ-6.0'],
        ['Battery Compartment/Clip is Damaged', 'BC-6.0'],
        ['Battery Corrosion', 'COR-6.0'],
        ['Patron Damage', 'CAD-6.0'],
        ['Other', 'OTH']
    ],
    launchpad: [
        ['Display not responding', 'TSU-LP'],
        ['Display Has Lines Through it or Color Issues', 'LCD-LP'],
        ['Device Will Not Power On', 'BAT-LP'],
        ['Device Will Not Charge', 'USB-LP'],
        ['Device Is Stuck On Home Screen', 'LOAD-LP'],
        ['No Sound / Sound Issues', 'PJ-LP'],
        ['Content Cleared', 'FIRM-LP'],
        ['Glass Broken or Cracked', 'DSP-CRK-LP'],
        ['Patron Damage - Other', 'CAD-LP'],
        ['Other', 'OTH']
    ]
};

class TableRow extends Component {
    static defaultProps = {
        className: '',
        product: {},
        isCart: false,
        discount: 0,
        isReadOnly: false,
        canDelete: true,
        showImage: true,
        showListPrice: true,
        showAudience: false,
        meta: ['authors', 'narrators', 'isbn', 'subtitle', 'studio', 'brand', 'sku'],
        hasAllocations: false,
        addToCart: () => {},
        onItemSelect: () => {},
        onItemAdd: () => {},
        onItemRemove: () => {},
        onPkgSelect: () => {}
    };

    state = {
        active_sku: null,
        active_isbn: null
    };

    handleAddToCart = (cartId) => {
        let { product } = this.props;
        let pkgType = product.format === 'bookpack' ? this._pkg_select.getValue() : null;
        this.props.onItemAdd({ ...product, pkg_type: pkgType });
    };

    handleDelete = (event) => {
        event.preventDefault();
        this.props.onItemRemove(this.props.product);
    };

    handleQtyChange = () => {
        if (!this._qty.getValue()) {
            return true;
        }

        this.props.onQtyChange(this.props.product.sku, this._qty.getValue());
    };

    handleAddWarranty = () => {
        this.props.onWarrantySelect(this.props.product, true);
    };

    handleRemoveWarranty = () => {
        this.props.onWarrantySelect(this.props.product, false);
    };

    handlePackageSelect = (e) => {
        let pkgType = this.props.product.format === 'bookpack' ? this._pkg_select.getValue() : null;

        if (this.props.isCart && this.props.product.format === 'bookpack') {
            this.props.onPkgSelect(this.props.product, pkgType);

            return;
        }

        this.setState({
            active_sku: this.props.product.packaging_data[pkgType].sku,
            active_isbn: this.props.product.packaging_data[pkgType].isbn
        });
    };

    render = () => {
        let { product, isCart, discount, isReadOnly, territory, currency } = this.props;
        if (!product.title) return null;
        let finalPrice = productUtils.getFinalPrice(product, discount, currency);
        let listPrice = productUtils.getListPrice(product, currency);
        let isAccessoryService = product.format
            ? product.format.includes('service') || product.format.includes('accessory')
            : false;
        let pkgType = this.props.defaultPkg ? this.props.defaultPkg : product.pkg_type;
        let history = (product.history || []).sort((a, b) => sorts.desc(a.submitted_date, b.submitted_date));
        let qtyProps = {};

        let format = product.format === 'recorded-books' ? 'playaway' : product.format;

        if (isAccessoryService && isCart) {
            qtyProps.value = product.qty;
            qtyProps.disabled = true;
        } else {
            qtyProps.defaultValue = product.qty;
        }

        let authors = product.authors || [];

        if (!Array.isArray(authors)) {
            authors = [authors];
        }

        let narrators = product.narrators || [];

        if (!Array.isArray(narrators)) {
            narrators = [narrators];
        }

        let reason =
            product.return_reason && reasons[format]
                ? reasons[format].find((i) => i[1] === product.return_reason)
                : null;

        return (
            <tr
                className={classnames('product', this.props.className, {
                    'ninexx-prod-row': this.props.hasAllocations
                })}
                key={`product_${product.id}`}
            >
                {this.props.showImage && (
                    <td>
                        <a
                            href={`http://shop.playaway.com/products/${product.slug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <ProductImage
                                product={product}
                                width={100}
                                imageType={product.format === 'wonderbook' ? 'cover' : 'hero'}
                            />
                        </a>
                    </td>
                )}

                <td className="product-title">
                    <div className="title">
                        <a
                            href={`http://shop.playaway.com/products/${product.slug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {productUtils.demangle(product.title || product.name)}
                        </a>
                    </div>
                    <div className="product-meta">
                        <ul>
                            {product.format !== 'lock' &&
                                !!authors.length &&
                                authors.filter((a) => a).length &&
                                this.props.meta.includes('authors') && (
                                    <li className="em">
                                        <strong>
                                            <FormattedPlural
                                                value={authors.filter((a) => a).length}
                                                one="Author"
                                                other="Authors"
                                            />
                                            :
                                        </strong>{' '}
                                        <AuthorList authors={authors} limit={1} searchKey="authors" />
                                    </li>
                                )}

                            {!!narrators.length &&
                                narrators.filter((a) => a).length &&
                                this.props.meta.includes('narrators') && (
                                    <li className="em">
                                        <strong>
                                            <FormattedPlural
                                                value={narrators.filter((a) => a).length}
                                                one="Narrator"
                                                other="Narrators"
                                            />
                                            :
                                        </strong>{' '}
                                        <AuthorList authors={narrators} limit={1} searchKey="narrators" />
                                    </li>
                                )}

                            {product.pack_type === 'Comics' &&
                                !!product.subtitle &&
                                this.props.meta.includes('subtitle') && (
                                    <li className="em">
                                        <strong>Subtitle:</strong> {product.subtitle}
                                    </li>
                                )}

                            {!!product.studio && this.props.meta.includes('studio') && (
                                <li className="em">
                                    <strong>Studio:</strong> {product.studio}
                                </li>
                            )}

                            {!!product.brand && this.props.meta.includes('brand') && (
                                <li className="em">
                                    <strong>Brand:</strong>{' '}
                                    {Array.isArray(product.brand) ? product.brand.join(',') : product.brand}
                                </li>
                            )}

                            {!!product.isbn && this.props.meta.includes('isbn') && (
                                <li className="em">
                                    <strong>ISBN:</strong> {this.state.active_isbn || product.isbn}
                                </li>
                            )}

                            {!!product.sku && this.props.meta.includes('sku') && (
                                <li className="em">
                                    <strong>SKU:</strong> {product.sku}
                                </li>
                            )}

                            {this.props.meta.includes('warranty') && (
                                <li className="em">
                                    <strong>Warranty:</strong>{' '}
                                    {product.include_warranty ? '2 years extended' : '1 year included'} <br />{' '}
                                    {isReadOnly ? null : product.include_warranty ? (
                                        <button
                                            type="button"
                                            className="button button-small button-success"
                                            onClick={this.handleRemoveWarranty}
                                        >
                                            Remove Extend warranty
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="button button-small button-success"
                                            onClick={this.handleAddWarranty}
                                        >
                                            Extend warranty 1 year
                                        </button>
                                    )}
                                </li>
                            )}
                            {product.orig_order_number && this.props.meta.includes('orig_order_number') && (
                                <li>
                                    <strong>Orginal Order:</strong>{' '}
                                    <Link to={`/orders/${product.orig_order_number}`}>{product.orig_order_number}</Link>
                                </li>
                            )}
                            {reason && this.props.meta.includes('orig_order_number') && (
                                <li>
                                    <strong>Return Reason:</strong> {reason[0]} ({reason[1]})
                                </li>
                            )}
                        </ul>
                        {!!history?.length && (
                            <div className="alert flash-info">
                                <Link to={`/account/orders/${history[0].order_number}`}>
                                    Purchased{' '}
                                    {new Date(history[0].submitted_date).toLocaleDateString('en-us', {
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })}
                                </Link>
                            </div>
                        )}
                    </div>
                </td>

                {this.props.showAudience && (
                    <td className="l-text-center">{productUtils.formatAgeLevel(product.age_level)}</td>
                )}

                {this.props.showListPrice && (
                    <td className="l-text-center">
                        <span className="price regular-price">
                            <FormattedNumber value={listPrice || 0.0} currency={currency} />
                        </span>
                    </td>
                )}

                <td className="l-text-center">
                    <span className="price final-price">
                        <FormattedNumber value={formatCurrency(finalPrice)} currency={currency} />
                    </span>
                </td>

                <td className="l-text-center">
                    {isReadOnly && product.qty}
                    {!isReadOnly && (
                        <Input
                            ref={(ref) => (this._qty = ref)}
                            className="qty"
                            id={`quantity_${product.sku}`}
                            value={product.qty}
                            onChange={debounce(this.handleQtyChange, 250)}
                        />
                    )}
                </td>

                <td className="l-text-center">
                    <PackageSelect
                        ref={(ref) => (this._pkg_select = ref)}
                        format={product.format}
                        includeStandard
                        value={pkgType || null}
                        onChange={this.handlePackageSelect}
                        readOnly={isReadOnly}
                    />
                </td>

                {this.props.showTotal && (
                    <td className="l-text-center">
                        <FormattedNumber
                            value={formatCurrency(productUtils.getTotal(product, discount, currency))}
                            currency={currency}
                        />
                    </td>
                )}

                {!isReadOnly && (
                    <td className="l-text-center">
                        {this.props.isCart ? (
                            this.props.canDelete ? (
                                <a href="#delete" onClick={this.handleDelete}>
                                    <i className="pw">
                                        <FaTrash />
                                    </i>
                                </a>
                            ) : null
                        ) : (
                            <AddButton
                                item={product}
                                onClick={this.handleAddToCart}
                                sku={product.sku}
                                territory={territory}
                            />
                        )}
                    </td>
                )}
            </tr>
        );
    };
}

export default TableRow;
